import { Component } from "react";
import withAuth from "../../../components/withAuth";
import { compose } from "redux";
import { connect } from "react-redux";
import { setHeader } from "../../../redux/analyseRisques/analyseRisquesActions";
import SelectWithModal from "../../../components/SelectWithModal/SelectWithModal";
import Timepicker from "../../../components/Input/Timepicker";
import FormControl from "@mui/material/FormControl/FormControl";
import { clone } from "../../../utils";
import "moment/locale/fr";
import InputMask from "react-input-mask";
import { TYPING_TIMEOUT } from "../../../constants";
import CustomizedTextField from "../../../components/Input/CustomizedTextField";
import DatePicker from "../../../components/Input/DatePicker";
import { Checkbox } from "@mui/material";

class AnalyseRisquesWorksNature extends Component {
    constructor(props) {
        super(props);
        this.state = {
            emergencyNumber: props.header.emergencyNumber,
            natureAndLocation: props.header.natureAndLocation,
            plannedOperationsDetails: props.header.plannedOperationsDetails,
            duration: props.header.duration,
            emergencyNumberTypingTimeout: null,
            natureAndLocationTypingTimeout: null,
            plannedOperationsDetailsTypingTimeout: null,
            durationTypingTimeout: null,
            timeout: TYPING_TIMEOUT,
        };
    }

    onEmergencyNumberChange(event) {
        let value = event.target.value;

        if (this.state.emergencyNumberTypingTimeout) {
            clearTimeout(this.state.emergencyNumberTypingTimeout);
        }

        this.setState({
            emergencyNumber: value,
            emergencyNumberTypingTimeout: setTimeout(() => {
                const header = clone(this.props.header);
                header.emergencyNumber = value;
                this.props.setHeader(header);
            }, this.state.timeout),
        });
    }

    onNatureAndLocationChange(event) {
        let value = event.target.value;

        if (this.state.natureAndLocationTypingTimeout) {
            clearTimeout(this.state.natureAndLocationTypingTimeout);
        }

        this.setState({
            natureAndLocation: value,
            natureAndLocationTypingTimeout: setTimeout(() => {
                const header = clone(this.props.header);
                header.natureAndLocation = value;
                this.props.setHeader(header);
            }, this.state.timeout),
        });
    }

    onStartDateChange(value) {
        const header = clone(this.props.header);
        header.startDate = value;
        this.props.setHeader(header);
    }

    onExpectedEndDateChange(value) {
        const header = clone(this.props.header);
        header.expectedEndDate = value;
        this.props.setHeader(header);
    }

    onLocaleAgencyChange(value) {
        const header = clone(this.props.header);
        header.localeAgency = value;
        this.props.setHeader(header);
    }

    onOnCallChange(e) {
        const header = clone(this.props.header);
        header.onCall = e.target.checked;
        this.props.setHeader(header);
    }

    onMorningScheduleStartChange(newValue) {
        const header = clone(this.props.header);
        header.morningScheduleStart = newValue;
        this.props.setHeader(header);
    }

    onMorningScheduleEndChange(newValue) {
        const header = clone(this.props.header);
        header.morningScheduleEnd = newValue;
        this.props.setHeader(header);
    }

    onAfternoonScheduleStartChange(newValue) {
        const header = clone(this.props.header);
        header.afternoonScheduleStart = newValue;
        this.props.setHeader(header);
    }

    onAfternoonScheduleEndChange(newValue) {
        const header = clone(this.props.header);
        header.afternoonScheduleEnd = newValue;
        this.props.setHeader(header);
    }

    onDurationChange(event) {
        let value = event.target.value;

        if (this.state.durationTypingTimeout) {
            clearTimeout(this.state.durationTypingTimeout);
        }

        this.setState({
            duration: value,
            durationTypingTimeout: setTimeout(() => {
                const header = clone(this.props.header);
                header.duration = value;
                this.props.setHeader(header);
            }, this.state.timeout),
        });
    }

    onPlannedOperationsDetailsChange(event) {
        let value = event.target.value;

        if (this.state.plannedOperationsDetailsTypingTimeout) {
            clearTimeout(this.state.plannedOperationsDetailsTypingTimeout);
        }

        this.setState({
            plannedOperationsDetails: value,
            plannedOperationsDetailsTypingTimeout: setTimeout(() => {
                const header = clone(this.props.header);
                header.plannedOperationsDetails = value;
                this.props.setHeader(header);
            }, this.state.timeout),
        });
    }

    render() {
        let selectedLocaleAgency = this.props.localeAgency;

        return (
            <div className="row full-height">
                <div className="col-lg-6 col-md-6 col-sm-12 col-12 control-margin-top">
                    <InputMask
                        mask="99 99 99 99 99"
                        maskChar=" "
                        value={this.state.emergencyNumber}
                        onChange={this.onEmergencyNumberChange.bind(this)}
                    >
                        {() => (
                            <CustomizedTextField
                                id="emergency-number"
                                label={"Numero d'urgence"}
                                className="full_size"
                            />
                        )}
                    </InputMask>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 col-12 control-margin-top">
                    <CustomizedTextField
                        id="nature-and-location"
                        label={"Nature et localisation"}
                        className="full_size"
                        multiline
                        required
                        value={this.state.natureAndLocation}
                        onChange={this.onNatureAndLocationChange.bind(this)}
                    />
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 col-12 control-margin-top">
                    <DatePicker
                        value={new Date(this.props.header.startDate)}
                        label={"Date de début"}
                        id="start-date"
                        emptyLabel="La date est invalide"
                        invalidDateMessage="La date est invalide"
                        invalidLabel="La date est invalide"
                        format="DD/MM/YYYY"
                        className={
                            "col-lg-12 col-md-12 col-sm-12 col-12 " +
                            (this.props.readonly ? "disabled" : "")
                        }
                        onChange={this.onStartDateChange.bind(this)}
                    />
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 col-12 control-margin-top">
                    <DatePicker
                        value={new Date(this.props.header.expectedEndDate)}
                        label={"Date de fin prévue"}
                        id="expected-end-date"
                        emptyLabel="La date est invalide"
                        invalidDateMessage="La date est invalide"
                        invalidLabel="La date est invalide"
                        format="DD/MM/YYYY"
                        className={
                            "col-lg-12 col-md-12 col-sm-12 col-12 " +
                            (this.props.readonly ? "disabled" : "")
                        }
                        onChange={this.onExpectedEndDateChange.bind(this)}
                    />
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 col-12 control-margin-top">
                    <SelectWithModal
                        label={"Agence *"}
                        onValidate={this.onLocaleAgencyChange.bind(this)}
                        value={selectedLocaleAgency}
                        name="locale-agency"
                        isClearable
                        className="full_size"
                        classNamePrefix="select"
                        required
                        options={this.props.companies.map((c) => {
                            return {
                                value: c.id,
                                label: c.name,
                            };
                        })}
                    />
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 col-12 row control-margin-top">
                    <div className="col-lg-6 col-md-6 col-sm-6 col-6 without-padding label-checkbox">
                        <span>Intervention en astreinte 24/24</span>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-6 col-6 without-padding">
                        <Checkbox
                            label={"Intervention en astreinte 24/24"}
                            checked={this.props.header.onCall}
                            onChange={this.onOnCallChange.bind(this)}
                            className="small-checkbox "
                        />
                    </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 col-12 control-margin-top">
                    <FormControl className="full_size top_spacing">
                        <Timepicker
                            id="morning-schedule-start"
                            mode="24h"
                            label="Heure de début du matin"
                            className="full_size"
                            value={
                                new Date(this.props.header.morningScheduleStart)
                            }
                            onChange={this.onMorningScheduleStartChange.bind(
                                this
                            )}
                        />
                    </FormControl>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 col-12 control-margin-top">
                    <FormControl className="full_size top_spacing">
                        <Timepicker
                            id="morning-schedule-end"
                            mode="24h"
                            label="Heure de fin du matin"
                            className="full_size"
                            value={
                                new Date(this.props.header.morningScheduleEnd)
                            }
                            onChange={this.onMorningScheduleEndChange.bind(
                                this
                            )}
                        />
                    </FormControl>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 col-12 control-margin-top">
                    <FormControl className="full_size top_spacing">
                        <Timepicker
                            id="afternoon-schedule-start"
                            mode="24h"
                            label="Heure de début de l'après midi"
                            className="full_size"
                            value={
                                new Date(
                                    this.props.header.afternoonScheduleStart
                                )
                            }
                            onChange={this.onAfternoonScheduleStartChange.bind(
                                this
                            )}
                        />
                    </FormControl>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 col-12 control-margin-top">
                    <FormControl className="full_size top_spacing">
                        <Timepicker
                            id="afternoon-schedule-end"
                            mode="24h"
                            label="Heure de fin de l'après midi"
                            className="full_size"
                            value={
                                new Date(this.props.header.afternoonScheduleEnd)
                            }
                            onChange={this.onAfternoonScheduleEndChange.bind(
                                this
                            )}
                        />
                    </FormControl>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 col-12 control-margin-top">
                    <CustomizedTextField
                        id="duration"
                        label={"Durée (en h)"}
                        className="full_size"
                        required
                        value={this.state.duration}
                        type="number"
                        onChange={this.onDurationChange.bind(this)}
                    />
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 col-12 control-margin-top">
                    <CustomizedTextField
                        id="planned-operations-details"
                        required
                        label={"Détails d'opérations planifiées"}
                        className="full_size"
                        multiline
                        value={this.state.plannedOperationsDetails}
                        onChange={this.onPlannedOperationsDetailsChange.bind(
                            this
                        )}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        header: state.analyseRisques.header,
        localeAgency: state.analyseRisques.header.localeAgency,
        companies: state.companies.companies,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setHeader: (header) => dispatch(setHeader(header)),
    };
};

export default compose(
    withAuth,
    connect(mapStateToProps, mapDispatchToProps)
)(AnalyseRisquesWorksNature);
